import {HoverPosition} from '../hooks/useDnDCanvasDragState';

/**
 * Computes the correct insertion index for a remove-then-insert move operation.
 *
 * When an item is removed from a list before being reinserted, every item after
 * the source shifts left by one. This function adjusts the target index to
 * account for that shift, then returns the final insertion index based on which
 * side of the target the drop occurred.
 */
export default function computeInsertIndexAfterRemoval(
  sourceIndex: number,
  targetIndex: number,
  hoverPosition: HoverPosition = 'right'
): number {
  const adjustedTargetIndex = sourceIndex < targetIndex ? targetIndex - 1 : targetIndex;
  return hoverPosition === 'left' ? adjustedTargetIndex : adjustedTargetIndex + 1;
}
